import styled from 'styled-components';
import { LinkButton } from '../Button';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ListTitle = styled.div`
  color: #444444;
  padding-bottom: 16px;
  text-transform: capitalize;
`;

export const ListContainer = styled.div`
  width: 100%;
`;

export const ItemsContainer = styled.div`
  border-radius: 4px;
  border: 1px solid #cccccc;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  height: 350px;
  overflow: auto;
`;

export const ItemButton = styled(LinkButton)`
  text-align: left;
  padding: 16px;
  background: ${props => (props.isSelected ? '#F2F9FF' : 'transparent')} !important;
  transition: background 0.3s ease;
`;

export const IncludeExcludeButtonsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
  padding: 0 16px;
`;

export const IncludeExcludeButton = styled(LinkButton)`
  background: #9c9c9c;
  border-radius: 50%;
  color: #ffffff;
  width: 24px;
  height: 24px;
  text-align: center;
  font-size: 13px;
  transition: background 0.3s ease;

  &:last-child {
    margin-top: 8px;
  }

  &:not(.disabled):active {
    background: #9c9c9c;
  }

  &:not(.disabled):focus,
  &:not(.disabled):hover {
    background: #767676;
  }
`;

export const Errors = styled.p`
  color: #e4433d;
`;
